import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../promo-code-list/model/promo-code-list.constants";
import { editPromoCode } from "./promo-code-edit.component.service";
import PromoCodeEditTemplateComponent from "./promo-code-edit.template.component";
import { getPromoCodeInputs } from "../model/promo-code.modal";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  PROMOCODE_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const PromoCodeEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let promoCodePayload = {};
    for (let i = 0; i < values.length; i++) {
      promoCodePayload[values[i].name] = values[i].value;
    }
console.log({promoCodePayload});
console.log(location.state.row.id);
    // INFO : call create api
    const promoCodeResponse = await editPromoCode(
      location?.state?.row?.id,
      promoCodePayload
    );
    console.log({location});
    console.log({promoCodePayload});
    console.log({promoCodeResponse});


    // INFO : check api response and show relevant alert message
    if (promoCodeResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: promoCodeResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getPromoCodeInputs({
      name: location?.state?.row?.name || "",
      code: location?.state?.row?.code || "",
      type: location?.state?.row?.type || "",
      code_value: location?.state?.row?.code_value || "",
      status: location?.state?.row?.status || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <PromoCodeEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default PromoCodeEditComponent;
